// extracted by mini-css-extract-plugin
module.exports = {"TypeWriter":"TypeWriter_TypeWriter__nkAPq","shine":"TypeWriter_shine__2_OOT"};